export default "__VITE_ASSET__CZAeL5Vl__"